<template>
  <button
    :style="[styles.container, { height: calcNum(44), color, fontSize: calcNum(fontSize) }, styleComputed]"
    @click="onClick"
  >
    <hy-image
      v-if="!backgroundColor && styleComputed.backgroundImage"
      :src="styleComputed.backgroundImage"
      :custom-style="{
        ...styles.bg,
        width:styleComputed.width,
        height:styleComputed.height,
        borderRadius:styleComputed.borderRadius,
      }"
    />
    <div :style="styles.content">
      <hy-image
        v-if="icon"
        :src="icon"
        :custom-style="{height:calcNum(iconHeight || 14),width:calcNum(iconWidth || 14),marginRight:calcNum(4)}"
      />
      <hy-text
        v-if="title"
        :color="styleComputed.color"
        :custom-style="{ fontSize: styleComputed.fontSize, color: styleComputed.color, fontWeight, ...titleStyle }"
      >
        {{ title }}
      </hy-text>
    </div>
    <slot />
  </button>
</template>

<script>
import HyImage from '@/components/basic/Image';
import HyText from '@/components/basic/Text/index';
import StyleSheet from '../StyleSheet';
import imageBtnPrimaryBg from './img/btn-primary-bg.png';

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#ffb400',
    // width: 100,
    // flex: 1,
  },
  bg: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 6,
    zIndex: 1,
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    flexDirection: 'row',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 6,
    zIndex: 2,
  },
});
export default {
  name: 'HyButton',
  components: {
    HyImage,
    HyText,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    // 默认 light 日间模式 dark 暗色模式 follow 关注按钮disabled时也是黑色字
    mode: {
      type: String,
      default: 'light',
    },
    size: {
      type: String,
      default: '',
    },
    iconWidth: {
      type: Number,
    },
    iconHeight: {
      type: Number,
    },
    width: {
      type: [String, Number],
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    fontSize: {
      type: Number,
      default: 14,
    },
    fontWeight: {
      type: [String, Number],
      default: '600',
    },
    color: {
      type: String,
      default: '#333',
    },
    backgroundColor: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    customStyle: {
      type: Object,
      default: () => {
      },
    },
    titleStyle: {
      type: Object,
      default: () => {
      },
    },
    disabled: {
      type: Boolean,
    },
    clickable: {
      type: [Boolean, String],
      default: '',
    },
    borderRadius: {
      type: Number,
      default: 6,
    },
  },
  data() {
    return {
      styles,
    };
  },
  computed: {
    styleComputed() {
      let style = {
        borderRadius: this.borderRadius,
        color: this.color,
      };

      if (!this.customStyle || !this.customStyle.backgroundColor || !this.customStyle.backgroundImage) {
        if (this.disabled) {
          if (this.mode === 'dark') {
            style.backgroundColor = '#737373';
            style.color = '#999999';
          } else if (this.mode === 'follow') {
            style.backgroundColor = '#F2F2F2';
            style.color = '#303133';
          } else {
            style.backgroundColor = '#F2F2F2';
            style.color = '#cccccc';
          }
        } else if (this.type === 'primary') {
          style.backgroundImage = imageBtnPrimaryBg;
          style.color = '#303133';
        } else if (this.type === 'secondary') {
          style.backgroundColor = '#ffe363';
          style.color = '#303133';
        } else if (this.type === 'normal') {
          style.backgroundColor = '#f2f2f2';
          style.color = '#303133';
        }
      }

      if (this.size) {
        switch (this.size) {
          case 's':
            style.height = 25;
            style.fontSize = 12;
            break;
          case 'm':
            style.height = 30;
            style.fontSize = 12;
            break;
          case 'l':
            style.height = 38;
            style.fontSize = 12;
            break;
          case 'xl':
            style.height = 50;
            style.fontSize = 14;
            break;
          default:
            style.height = 30;
            style.fontSize = 12;
            break;
        }
      } else {
        style.fontSize = this.fontSize;
      }

      if (this.width === 'auto') {
        style.flex = 1;
      } else if (this.width > 0) {
        style.width = Number(this.width);
      }

      style = {
        ...style,
        ...this.customStyle,
      };
      return StyleSheet.create({ style }).style;
    },
  },
  methods: {
    onClick(e) {
      if (this.clickable === true) {
        this.$emit('click', e);
      } else if (this.clickable === false) {
        return false;
      } else if (!this.disabled) {
        this.$emit('click', e);
      }
    },
  },
};
</script>
